import styled from "styled-components"

import tokens from "../_tokens"

const Paragraph = styled.p`
  margin: 0 0 ${1.5 * tokens.size.base}px;
`

export default Paragraph
